import { render } from "./TableProduct.vue?vue&type=template&id=7be4a62e&scoped=true"
import script from "./TableProduct.vue?vue&type=script&lang=js"
export * from "./TableProduct.vue?vue&type=script&lang=js"

import "./TableProduct.vue?vue&type=style&index=0&id=7be4a62e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be4a62e"]])

export default __exports__